class @App.Components.ClubsPrepare
  constructor: ->
    @$element = $('[data-component="clubs-prepare"]')
    @$counter = $('[data-component="prepare-members"]')
    @$template = @$element.find('[data-prepare="template"]').first()

    @updateCounter()

    @$element.on 'click', '[data-action="prepare-add-row"]', (e) =>
      e.preventDefault
      $('<tr data-prepare="member" />').html(@$template.html()).insertBefore(@$template)
      false

    @$element.on 'change', '[data-prepare="permission-form"]', (e) =>
      $input = $(e.target)
      if e.target.files.length > 0
        console.log e.target.files[0].name
        $('<span />')
          .text(e.target.files[0].name)
          .insertAfter($input.closest('label'))
        $input.parent('label').hide()
        # Upload file AJAX?
      false


  updateCounter: =>
    items = @$element.find('[data-prepare="status"][data-status="done"]').length
    @$counter.text(items)
    return

$ ->
  new App.Components.ClubsPrepare
